import React, { useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { validDecimal } from 'app/helpers/numberHelper';
import { Controller, useFormContext } from 'react-hook-form';
import { getExistingRow, getNewRow } from './TimeOffHours';
import { useTranslation } from 'react-i18next';


export const DailyCostTimeOffCell = (cellParams: any) => {
  return <DailyCostTimeOff cellParams={cellParams} />;
};

const DailyCostTimeOff = React.memo(function DailyCostTimeOff(cellParams: any) {
  const dispatch = useDispatch();
  const { control } = useFormContext();
  const { t } = useTranslation();
  const cost = cellParams?.cellParams?.row?.cost;
  const [timeOffDaily, setTimeOffDaily] = useState(cost === '--' ? '' : cost);
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const RowId = cellParams?.cellParams?.id;

  const setDailyForTimeOffEdit = data => {
    let newRow = timeOffEditRequests.slice(0);

    let timeOffEditRow = cellParams?.cellParams?.row?.placementTimeOffId
      ? getExistingRow(timeOffEditRequests, cellParams)
      : getNewRow(timeOffEditRequests, RowId);

    let updatedEndDate = { ...timeOffEditRow, cost: data ? parseFloat(data) : '' };

    let editDateIndex = timeOffEditRequests?.findIndex(
      cellParams?.cellParams?.row?.placementTimeOffId
        ? row => row.placementTimeOffId === updatedEndDate.placementTimeOffId
        : row => row.id === RowId,
    );

    newRow[editDateIndex] = updatedEndDate;

    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  const checkValidDecimal = (value, onChange) => {
    if (validDecimal(value, { numberLength: 6, decimalLength: 2 })) {
      setTimeOffDaily(value);
      onChange(value);
    } else {
      setTimeOffDaily(value.slice(0, -1));
      onChange(null);
    }
  };

  return (
    <>
      <Controller
        name={`timeOffRequests${RowId}.hours`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            variant="outlined"
            size={'small'}
            style={{ width: '150px' }}
            value={timeOffDaily}
            onBlur={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setDailyForTimeOffEdit(e.target.value);
              }
              onChange(e.target.value);
            }}
            InputProps={{
             
              startAdornment: (
                <>{<InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>
              ),
              sx: { fontSize: '14px' },
            }}
            onChange={e => {
              if (e.target.value) {
                checkValidDecimal(e.target.value, onChange);
              } else {
                setTimeOffDaily(null);
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
